import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { EndasureService } from 'src/app/services/feature/Endasure/endasure.service';

@Component({
  selector: 'app-endasure-main',
  templateUrl: './endasure-main.component.html',
  styleUrls: ['./endasure-main.component.scss'],
  standalone: false
})
export class EndasureMainComponent {
  currentComponent: string;
  isMobile: any;
  endSureDropDown$: Observable<any> = this.endasureService.getbrandOfActuator().pipe(
    map((x: any) => {
      return x.dropdown.sort((a: any, b: any) => {
        // Compare 'name' properties of two objects to determine order
        if (a.name < b.name) {
          return -1;
        } else if (a.name > b.name) {
          return 1;
        } else {
          return 0;
        }
      });
    })
  );
  private readonly destroy$ = new Subject<void>();
  constructor(
    private readonly endasureService: EndasureService,
    private readonly cdr: ChangeDetectorRef,
    private readonly BreakpointObserver: BreakpointObserver
  ) {
    this.BreakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
      this.isMobile = result.matches;
    });
  }

  ngOnInit() {
    this.endasureService.currentComponent$.pipe(takeUntil(this.destroy$)).subscribe((x) => {
      if (x != null) {
        this.currentComponent = x;
      } else {
        this.currentComponent = 'visitorInfo';
      }
      this.cdr.detectChanges();
    });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
